import { jsx, jsxs } from 'react/jsx-runtime';
import classnames from 'classnames';
import { AdTypes } from '@sbt-web/network/types';
import { wholeNumberPrice } from '@sbt-web/utils';
import 'react';
import '@radix-ui/react-accordion';
import '../../UIElements/Accordion/partials/AccordionPanel.js';
import '../../UIElements/AllCategoriesModal/categories.js';
import '../../UIElements/AllCategoriesModal/config.js';
import '@sbt-web/category-utils';
import { Badge } from '../../UIElements/Badge/index.js';
import 'radix-ui';
import '../../lib/constants.js';
import '../../UIElements/Icon/index.js';
import '../../UIElements/Button/index.js';
import '../../UIElements/ButtonLink/index.js';
import '../../UIElements/Chip/index.js';
import '../../UIElements/Divider/index.js';
import '../../UIElements/ListItem/ItemRadio/index.js';
import '../../UIElements/ListItem/ItemCheckBox/index.js';
import '../../UIElements/Loader/index.js';
import '../../UIElements/Notifications/NotificationsContainer/index.js';
import '../../UIElements/StaticChip/StaticChip.js';
import '../../UIElements/TextLink/index.js';
import '../../Icons/ArrowDown/index.js';
import '../../Icons/Camera/index.js';
import '../../Icons/Category/index.js';
import '../../Icons/CheckCircle/index.js';
import '../../Icons/Close/index.js';
import '../../Icons/Favorite/index.js';
import '../../Icons/Lens/index.js';
import '../../Icons/LensHeart/index.js';
import '../../Icons/Phone/index.js';
import '../../Icons/Pin/index.js';
import '../../Icons/Promo/index.js';
import '../../Icons/Share/index.js';
import '../../Icons/Bell/index.js';
import '../../Icons/Bin/index.js';
import '../../Icons/Check/index.js';
import '../../Icons/TriangleExclamation/index.js';
import '../../Icons/ShoppingBag/index.js';
import '../../UIElements/Pagination/index.js';
import ownClasses from './index.module.scss.js';

const Truck = ({ classes = [], withAlt = false, }) => (jsxs("svg", { width: "16", height: "12", xmlns: "http://www.w3.org/2000/svg", className: classnames(classes), "aria-hidden": !withAlt, children: [withAlt ? jsx("title", { children: "Spedizione disponibile" }) : null, jsx("path", { d: "M5.5 7c.817 0 1.543.392 2 .999H9V2H7a1 1 0 01-.993-.883L6 1a1 1 0 01.883-.993L7 0h3a1 1 0 01.993.883L11 1v1h2a1 1 0 01.757.346l.075.1 2 3a1 1 0 01.161.436L16 6v3a1 1 0 01-.883.993L15 10h-.05a2.5 2.5 0 01-4.9 0H10l-.017-.001H7.95a2.5 2.5 0 01-4.9 0H2a1 1 0 01-.993-.882L1 9V7a1 1 0 011.993-.117L3 7v.999h.5A2.496 2.496 0 015.5 7zm7 2a.5.5 0 100 1 .5.5 0 000-1zm-7 0a.5.5 0 100 1 .5.5 0 000-1zm6.964-5H11v3.5c.418-.314.937-.5 1.5-.5s1.083.186 1.501.5L14 6.305 12.464 4zM4 3a1 1 0 01.117 1.993L4 5H2a1 1 0 01-.117-1.993L2 3h2zm0-3a1 1 0 01.117 1.993L4 2H1A1 1 0 01.883.007L1 0h3z" })] }));
const ShippingDetails = ({ info, classes = [] }) => {
    if (!info.shippable) {
        return null;
    }
    else {
        const isOnDetail = info.display === 'detail';
        const isOnCard = !isOnDetail;
        return (jsxs(Badge, { themed: true, inverted: true, classes: [
                ...classes,
                ownClasses.badge,
                classnames({
                    [ownClasses.card]: isOnCard,
                    [ownClasses['card-with-truck']]: isOnCard,
                    [ownClasses.detail]: isOnDetail,
                }),
                'shipping-badge',
            ], flavor: "small", children: [jsx(Truck, { classes: [
                        ownClasses.truck,
                        classnames({ [ownClasses['detail-truck']]: isOnDetail }),
                    ], withAlt: isOnCard }), isOnDetail ? 'Spedizione disponibile' : null] }));
    }
};
const SoldItemBadge = ({ info, classes = [] }) => {
    if (info.isItemSold) {
        const isOnDetail = info.display === 'detail';
        return (jsx(Badge, { flavor: "normal", classes: [
                ...classes,
                ownClasses.badge,
                classnames({
                    [ownClasses.card]: !isOnDetail,
                    [ownClasses.detail]: isOnDetail,
                }),
                'item-sold-badge',
            ], children: "Venduto" }));
    }
    else {
        return null;
    }
};
const ItemPrice = (props) => {
    const { classes = [], size = 'small', price, adType } = props;
    let priceMessage = '';
    let isNumericalPrice = false;
    if (adType === AdTypes.GiveAway) {
        priceMessage = 'In regalo';
    }
    else if (price != null && !isNaN(price) && price > 0) {
        priceMessage = wholeNumberPrice.format(price);
        isNumericalPrice = true;
    }
    else if (props.badgeConfiguration == undefined) {
        // Do not render anything if the badgeConfiguration is not defined.
        return null;
    }
    // This is a price which risks overflowing into the badge, and so
    // forces the badge onto a new line.
    const isLongPrice = isNumericalPrice && priceMessage.replace(/[^0-9]/g, '').length >= 7;
    return (jsx("div", { className: ownClasses['price-group'], children: jsxs("p", { className: classnames(ownClasses.price, classes, {
                [ownClasses['no-item-available-price']]: props.badgeConfiguration?.isItemSold,
                [ownClasses['badge-below']]: (props.badgeConfiguration?.isItemSold &&
                    props.badgeConfiguration?.display === 'card') ||
                    isLongPrice,
                [ownClasses.small]: size === 'small',
                [ownClasses.large]: size === 'large',
            }), children: [priceMessage, props.badgeConfiguration != undefined ? (
                // These badges are mutually exclusive by the nature of the
                // features that power them.
                props.badgeConfiguration.isItemSold ? (jsx(SoldItemBadge, { info: props.badgeConfiguration })) : (jsx(ShippingDetails, { info: props.badgeConfiguration }))) : null] }) }));
};

export { ItemPrice };
//# sourceMappingURL=index.js.map
